
  import {Component, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportTable from "@/modules/Report/components/ReportTable.vue";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import {IApp} from "@/interfaces/app.interface";
  import {httpResource} from "@/resources/http.resource";
  import {PrintAgentReport} from "@/modules/Report/mixins/print-agent-report";
  import {isMobile} from "mobile-device-detect";
  import {IAgentReport} from "@/modules/Report/interfaces/agent-report.interface";
  import moment from "moment";
  import AgentTableTotal from "@/modules/Report/components/AgentTableTotal.vue";
  import {IAppState} from "@/interfaces/app-state.interface";
  import ReportAgentSummary from "@/modules/Report/components/SpecialComponents/ReportAgentSummary.vue";

  @Component({
    components: {
      ReportAgentSummary,
      AgentTableTotal,
      ReportTable,
    }
  })
  export default class ReportTableAgent extends Vue {

    get storeState(): IAppState { return this.$store.state; }
    get filters(): IReport.IFilters { return this.storeState.report.filters; }
    get loading() { return this.storeState.report.loading; }
    get tableList(): IAgentReport.IDataItem[] { return this.$store.getters['report/sortedList'].array; }
    get dataProps(): IReport.ITableProp[] {
      let result = [
        {
          label: isMobile ? 'Дата' : 'Дата оплаты',
          prop: 'payDate',
          propType: IApp.SortingPropType.Date,
          dateFormat: isMobile ? IApp.DateFormats.PrintedDateShort : IApp.DateFormats.PrintedDate,
          actionClick: (row) => this.openMovementReport(row),
          addClassFunction: (row) => 'text-hover-underline',
        },
        { label: isMobile ? 'День' : 'День недели',        prop: 'payDateDay', propType: IApp.SortingPropType.String, noSorting: true, },
        { label: 'Сумма',                                  prop: 'sumPays', propType: IApp.SortingPropType.Number, isMoney: true, },
        { label: isMobile ? 'Кол-во' : 'Количество оплат', prop: 'cntPays', propType: IApp.SortingPropType.String, },
      ];

      if (!this.filters.groupTypes || (this.filters.groupTypes && !this.filters.groupTypes.length)) {
        let avgCell = { label: isMobile ? 'Ср. чек' : 'Средний чек', prop: 'avgSum', propType: IApp.SortingPropType.Number, isMoney: true, };
        result.splice(2, 0, avgCell);
      }

      return result;
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }

    created() {
      this.$store.commit('report/setProperty', {
        name: 'sortingTable',
        value: {
          prop: 'payDate',
          propType: IApp.SortingPropType.Date,
          direction: IApp.SortDirection.Down,
        },
      });
    }

    async openMovementReport(row: IAgentReport.IDataItem) {
      await this.$store.dispatch('openPage', {
        routeName: IApp.ROUTE_NAME.PAGE_REPORT_MOVEMENTS,
        params: {
          filters: {
            dateBeg: moment(row.payDate).format(IApp.DateFormats.PrintedDate),
            dateEnd: moment(row.payDate).format(IApp.DateFormats.PrintedDate),
            parks: [...this.filters.parks],
            payFlag: true,
          },
        },
      });
    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.storeState.report.activeReport,
        filters: {...this.filters},
      });
    }

    async loadDataForPrint() {
      let asyncAction = async () => {
        const action = IReport.Action;
        const params: any = {
          ...IReport.PrepareFilters(this.filters),
          pdfFlag: true,
        };
        params.command = this.storeState.report.activeReport;

        const {data: {result: reportData}} = await httpResource.httpAction({action, params});
        return reportData;
      };

      return await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async printTable() {
      const { response } = await this.loadDataForPrint();
      PrintAgentReport(response.printData, response.table);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }
  }
